module.exports = __webpack_public_path__ + "static/media/Night_mode.0906557a.png";